import { observable, action, toJS } from "mobx";
import base from '../../tool/base';
import util from '../../util/index';

const {
  catchApiError,
  getAccessToken
} = util;

class EcodeCollectStore {
  constructor(routing) {
    this.routing = routing;
  }

  @observable demoType = 'portalTheme';
  @observable loading = false;
  @observable pageNum = 1;
  @observable pageSize = 10;
  @observable title = '';
  @observable createDate = '';
  @observable collectList = [];
  @observable collectCount = 0;
  @observable loading = false;

  @action
  setMobxState = (params = {}) => {
    Object.keys(params).forEach(key => {
      this[key] = params[key];
    })
  }
  
  @action
  initSearch = () => {
    this.title = '';
    this.createDate = '';
  }

  @action
  getCollectList = (params = {}) => {
    this.loading = true;
    params = {
      pageNum: this.pageNum,
      pageSize: this.pageSize,
      demoType: this.demoType,
      title: this.title,
      createDate: this.createDate,
      ...params,
      access_token: getAccessToken(),
    };
    Object.keys(params).forEach(key => !params[key] && delete params[key])
    return new Promise(resolve => {
      base.callApi('/v5/collect/collectList', 'POST', params, 'json', 'text').then((data) => catchApiError(data, this.routing)).then(result => {
        if (result.status) {
          this.collectList = result.data;
          this.collectCount = result.count;
          resolve(result);
        }
        this.loading = false;
      });
    });
  }

  @action
  deleteCollect = (params = {}) => {
    this.loading = true;
    params = {
      ...params,
      access_token: getAccessToken(),
    };
    return new Promise(resolve => {
      base.callApi('/v5/collect/deleteCollect', 'POST', params, 'json', 'text').then((data) => catchApiError(data, this.routing)).then(result => {
        if (result.status) {
          resolve(result);
        }
        this.loading = false;
      });
    });
  }

}

export default EcodeCollectStore;


// WEBPACK FOOTER //
// ./src/stores/collect/EcodeCollectStore.js